<script lang="ts">
	import { format } from 'svelte-i18n';
	import { rooms } from 'src/stores/lists/rooms';
	import { scenes } from 'src/stores/lists/scenes';
	import { is_automation_condition_ui } from '../../../../../../../../types/AutomationConditionUI';
	import { navigateToShop, sortByPosition } from '../../../../../../../Lists/list-helpers';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../helpers/when-wizard-helpers';
	import EmptyList from 'src/components/Lists/EmptyList.svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	export let sceneData: any;
	export let firstSelectedRef: HTMLElement = null;

	const setSelectedSortedScenes = () => {
		return [
			{ value: -1, title: 'Global', id: -1 },
			...Object.values($rooms)
				.sort(sortByPosition)
				.map((room: any) => {
					// return { value: el.id, title: el.name };
					return { title: room.name, value: room.id, id: room.id };
				}),
		]
			.map((room) => {
				const scenesByRoom = Object.values($scenes)
					.filter((sc: any) => {
						//if it's not a temp scheme or an alarm
						if (sc.toheat === undefined && sc._gui_function !== 'alarm') {
							return Number(room.id) === -1
								? sc._meta.room == room.id || sc._meta.room === ''
								: sc._meta.room == room.id;
						}
					})
					.map((scene: any) => {
						return {
							id: scene._id,
							value: scene._id,
							title: scene._meta.name,
							name: scene._meta.name,
							image: scene._meta.image,
							backgroundColor: scene._meta.backgroundColor,
							selected: sceneData._automation_condition.scene_id === scene._id,
						};
					});

				return {
					cards: scenesByRoom,
					roomID: room.id,
					roomName: room.title,
				};
			})
			.filter((room) => room.cards.length > 0);
	};

	const validateWizardSceneSelect = () => {
		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.DEVICE_PROPS_STEP;
		sceneData.isValid = true;
	};

	let sortedRoomsWithScenes = setSelectedSortedScenes();

	if (is_automation_condition_ui(sceneData.translated)) {
		//find selected automation
		//find room if it is a scene
		//find selected item
		sceneData._automation_condition = {
			scene_id: sceneData.translated.scene_id,
			selected: true,
		};

		sortedRoomsWithScenes = setSelectedSortedScenes();
	}

	// $: {
	// 	sceneData.isValid =
	// 		sceneData._automation_condition.scene_id !== '' &&
	// 		sceneData._automation_condition.selected;
	// }

	const onSelectScene = (scene) => {
		validateWizardSceneSelect();

		sceneData._automation_condition.scene_id = scene.value;
		sceneData._automation_condition.selected = scene.value !== undefined;

		sortedRoomsWithScenes = sortedRoomsWithScenes.map((room) => {
			const cards = room.cards.map((card) => {
				let selected = false;
				if (card.id === scene.id) {
					selected = true;
				}

				return { ...card, selected };
			});

			return {
				...room,
				cards,
			};
		});
	};
</script>

<SelectList
	class="mb-s"
	title={$format('label_select_scene', {
		default: 'Select scene',
	})}
	list={sortedRoomsWithScenes}
	variant="radio"
	on:click={(e) => onSelectScene(e.detail)}
	bind:firstSelectedRef
/>

{#if !sortedRoomsWithScenes.length}
	<div class="d-flex flex-direction-column justify-content-center align-items-center mt-s">
		<EmptyList
			withoutMargin
			type="modal"
			title={$format('on_board_get_device_title', {
				default: 'Get the necessary devices to set up.',
			})}
			description={$format('on_board_get_device_description', {
				default:
					'Currently you don’t have the necessary devices. Please get the necessary devices to set up your automations.',
			})}
			btnText={capFirstChar(
				$format('button_go_to_store', {
					default: 'Go to store',
				}).toLocaleLowerCase(),
			)}
			onClick={() => {
				navigateToShop();
			}}
		/>
	</div>
{/if}
